import { getAnnouncements } from '@services/external/announcements.api';
import { call, put, takeLatest } from 'typed-redux-saga/macro';
import { alertsActionTypes } from '../ducks/alerts';

function* getHistoryRequest() {
  try {
    const response = yield* call(() => getAnnouncements({ type: 'all', page: 1, pageSize: 30 }));
    const result = response.data;

    // @ts-expect-error
    const sorted = result.data.items.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    yield put({
      type: alertsActionTypes.GET_HISTORY_SUCCESS,
      payload: sorted,
    });
  } catch {}
}

function* alerts() {
  yield takeLatest(alertsActionTypes.GET_HISTORY_REQUEST, getHistoryRequest);
}

export default alerts;
